import styled from 'styled-components';

export const ReportAdmin = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100%;
  display: flex;
  justify-content: center;

  .tabs {
    margin: 0 1rem;
  }

  .form-page {
    width: 100vw;
  }
`;
